import { BackrsFormField } from '@backrs_ui/common-ui';

import { FieldValues } from 'react-hook-form';

export const SETTINGS_FIELDS: Record<
  keyof FieldValues,
  BackrsFormField & { hideDivider?: boolean; label: string }
> = {
  firstName: { name: 'firstName', label: 'First Name' },
  lastName: { name: 'lastName', label: 'Last Name' },
  email: {
    name: 'email',
    label: 'Email',
    type: 'email',
    icon: {
      type: 'LEFT_ICON',
      leftIcon: 'Mail01',
      leftIconSize: '20px',
      leftIconColor: 'Gray/600',
    },
    rules: {
      required: 'Email is required',
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: 'Invalid email address',
      },
    },
  },
  phone: {
    name: 'phone',
    label: 'Phone',
    type: 'tel',
    icon: {
      type: 'LEFT_ICON',
      leftIcon: 'Phone',
      leftIconSize: '20px',
      leftIconColor: 'Gray/600',
    },
    rules: {
      pattern: {
        value: /^[0-9]{10}$/,
        message: 'Invalid phone number',
      },
    },
  },
  zipCode: {
    name: 'zipCode',
    label: 'Zip Code',
    icon: {
      type: 'LEFT_ICON',
      leftIcon: 'US',
      leftIconSize: '20px',
      leftIconColor: 'Gray/600',
    },
    rules: {
      pattern: {
        value: /^[0-9]{5}$/,
        message: 'Invalid zip code',
      },
    },
  },
  birthday: {
    name: 'birthday',
    label: 'Birthday',
    hideDivider: true,
    type: 'date',
    icon: {
      type: 'LEFT_ICON',
      leftIcon: 'CalendarPlus01',
      leftIconSize: '16px',
      leftIconColor: 'Gray/600',
    },
  },
  newPassword: {
    name: 'newPassword',
    label: 'New Password',
    type: 'password',
    rules: {
      validate: (value, values) => {
        if (!value && !values?.confirmPassword) return true;
        if (value.length < 8) return 'Your new password must be more than 8 characters.';

        return true;
      },
    },
  },

  confirmPassword: {
    name: 'confirmPassword',
    label: 'Confirm New Password',
    type: 'password',
    rules: {
      validate: (value, values) => {
        if (!value && !values?.newPassword) return true;
        if (value !== values?.newPassword) return 'Passwords do not match';

        return true;
      },
    },
  },
} as const;

export const SECTIONS_KEYS = {
  NAME: ['firstName', 'lastName'],
  OTHER: ['email', 'phone', 'zipCode', 'birthday'],
  PASSWORD: ['newPassword', 'confirmPassword'],
} as const;
